import script from "./UmbrellaCampaignDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UmbrellaCampaignDetail.vue?vue&type=script&setup=true&lang=js"

import "./UmbrellaCampaignDetail.vue?vue&type=style&index=0&id=60eb5fad&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60eb5fad"]])

export default __exports__